import { QueryKey } from '@/configs/queryKeys';
import { Attachment, Relation } from '@/types';
import { FormTemplate } from '@/remoteApi/types/form-template.types';
import EntityApi, { BaseEntity } from './EntityApi';

export enum SectionType {
	CARDS = 'CARDS',
	LISTS = 'LISTS',
	ARTICLES = 'ARTICLES',
}

interface ProductTypeSection {
	title: string;
	description: string;
}

export interface ProductTypeSectionCard extends ProductTypeSection {
	cards: { title: string; description: string }[];
}

export interface ProductTypeSectionLists extends ProductTypeSection {
	lists: { title: string; entries: string[] }[];
}

export interface ProductTypeSectionArticles extends ProductTypeSection {
	articles: { title: string; description: string; image: Attachment | null }[];
}

export interface PredefinedDimension {
	width: number;
	height: number;
	depth: number;
	relations: Relation[] | undefined;
}

export interface ProductType extends BaseEntity {
	externalId: number;
	name: string;
	description: string;
	image?: Attachment;
	formTemplate: FormTemplate;
	isPerDimensionQuantityEnabled: boolean;
	predefinedDimensions: PredefinedDimension[];
	minCustomDimensionQuantity: number;
	content: {
		[SectionType.CARDS]: ProductTypeSectionCard;
		[SectionType.LISTS]: ProductTypeSectionLists;
		[SectionType.ARTICLES]: ProductTypeSectionArticles;
	};
}

class ProductTypeApi extends EntityApi<ProductType> {
	constructor() {
		super(QueryKey.productType);
	}
}

export default new ProductTypeApi();
